/**
 * The version of the build currently running.
 *
 * Replaced literally at build time, which is the point: the string is compiled
 * into the same bundle as the code it describes, so it cannot drift from what
 * is actually running. Reading it from a file or an API could.
 *
 * `typeof` rather than a bare reference so that anything importing this outside
 * a Vite build — tests, tooling — gets "dev" instead of a crash. It is the one
 * operator that tolerates an undeclared name.
 */
export const APP_VERSION: string =
  typeof __APP_VERSION__ === "string" ? __APP_VERSION__ : "dev";
